import PropTypes from 'prop-types';
export const propTypes = {
    data: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
    autoplay: PropTypes.bool,
    initialIndex: PropTypes.number,
    onIndexChanged: PropTypes.func,
    dotStyle: PropTypes.object,
    activeDotStyle: PropTypes.object,
    loop: PropTypes.bool,
    theme: PropTypes.object,
    showsPagination: PropTypes.bool,
};
export const defaultProps = {
    autoplay: false,
    initialIndex: 0,
    loop: false,
    showsPagination: true,
};
